import {Delegate} from "../Tools/Delegate.js";

export const OnProjetDelete = new Delegate();
export const OnProjetAdd = new Delegate();
export const OnProjetUpdate = new Delegate();
